import {
  AddressTypeCode,
  GetAddresses,
  GetDigitalAddress,
  QuickAddressesResponse,
  QuickAddressResponse,
  SaveAddressResponse,
  SaveDigitalAddress,
} from '../global-types/addresses';

export const savedAddressResponse: SaveAddressResponse = {
  meta: {
    code: 201,
    version: '2.2.0',
  },
  data: {
    address_id: 'de2f6bfc-aa93-493a-a9e2-ffbe75bf3061',
    first_name: 'Test',
    last_name: 'Test',
    display_name: 'Test Test',
    company_name: '',
    address_line_1: '2501 MCgee St',
    address_line_2: '',
    city: 'Kansas City',
    state_code: 'MO',
    zip: '64108',
    country_code: 'USA',
    address_type_code: AddressTypeCode.SENDER,
    created_at: '2020-06-09T03:51:45.013368587Z',
    last_updated_at: '2020-06-09T03:51:45.013368587Z',
    is_verified: false,
    is_valid: true,
  },
};

export const getAddressesResponse: GetAddresses = {
  meta: {
    code: 201,
    version: '2.2.0',
  },
  data: [
    {
      address_id: 'de2f6bfc-aa93-493a-a9e2-ffbe75bf3061',
      first_name: 'Test',
      last_name: 'Test',
      display_name: 'Test Test',
      company_name: '',
      address_line_1: '2501 MCgee St',
      address_line_2: '',
      city: 'Kansas City',
      state_code: 'MO',
      zip: '64108',
      country_code: 'USA',
      address_type_code: AddressTypeCode.SENDER,
      created_at: '2020-06-09T03:51:45.013368587Z',
      last_updated_at: '2020-06-09T03:51:45.013368587Z',
      is_verified: false,
      is_valid: true,
    },
    {
      address_id: 'de2f6bfc-aa93-493a-a9e2-ffbe75bf3062',
      first_name: 'Test',
      last_name: 'Test',
      display_name: 'Test Test',
      company_name: '',
      address_line_1: '2501 MCgee St',
      address_line_2: '',
      city: 'Kansas City',
      state_code: 'MO',
      zip: '64108',
      country_code: 'USA',
      address_type_code: AddressTypeCode.RECIPIENT,
      created_at: '2020-06-09T03:51:45.013368587Z',
      last_updated_at: '2020-06-09T03:51:45.013368587Z',
      is_verified: false,
      is_valid: true,
    },
  ],
};

export const quickAddressResponse: QuickAddressResponse = {
  meta: {
    code: 201,
    version: '2.2.0',
  },
  data: {
    contact_id: 'de2f6bfc-aa93-493a-a9e2-ffbe75bf3061',
    account_id: '2124857521',
    first_name: 'TestFirst',
    last_name: 'TestLast',
    display_name: 'TestFirst TestLast',
    company_name: 'TestCompany',
    address_line_1: '2501 MCgee St',
    address_line_2: 'Main Office',
    city: 'Kansas City',
    state_code: 'MO',
    zip: '64108',
    country_code: 'USA',
    contact_type_code: 'A',
    created_at: '2020-06-09T03:51:45.013368587Z',
    last_updated_at: '2020-06-09T03:51:45.013368587Z',
    is_verified: true,
  },
};

export const quickAddressesResponse: QuickAddressesResponse = {
  meta: {
    code: 200,
    version: '2.2.0',
  },
  data: {
    contacts: [
      {
        contact_id: 'de2f6bfc-aa93-493a-a9e2-ffbe75bf3061',
        account_id: '2124857521',
        first_name: 'TestFirst',
        last_name: 'TestLast',
        display_name: 'TestFirst TestLast',
        company_name: 'TestCompany',
        address_line_1: '2501 MCgee St',
        address_line_2: 'Main Office',
        city: 'Kansas City',
        state_code: 'MO',
        zip: '64108',
        country_code: 'USA',
        contact_type_code: 'A',
        created_at: '2020-06-09T03:51:45.013368587Z',
        last_updated_at: '2020-06-09T03:51:45.013368587Z',
        is_verified: true,
        address_hash_id: '5d05d14c3f7672ac5b5e8cce1f8a2f2ab37ca2cd',
      },
      {
        contact_id: 'de2f6bfc-aa93-493a-a9e2-ffbe75bf3062',
        account_id: '2124857521',
        first_name: 'First',
        last_name: 'Last',
        display_name: 'First Last',
        company_name: 'Company',
        address_line_1: '2501 MCgee St',
        address_line_2: 'Main Office',
        city: 'Kansas City',
        state_code: 'MO',
        zip: '64108',
        country_code: 'USA',
        contact_type_code: 'A',
        created_at: '2020-06-09T03:51:45.013368587Z',
        last_updated_at: '2020-06-09T03:51:45.013368587Z',
        is_verified: true,
        address_hash_id: '6082e09d127eaa23a5e23b737996dc358ec37cf7',
      },
    ],
    paging: {
      total_pages: 1,
      total_items: 2,
      next_page: null,
    },
  },
};

export const digitalAddresGetResponse: GetDigitalAddress = {
  meta: {
    code: 200,
    version: '2.2.0',
  },
  data: [
    {
      recipient_id: 'de2f6bfc-aa93-493a-a9e2-ffbe75bf3061',
      recipient_first_name: 'TestRecipientFirstName',
      recipient_last_name: 'TestRecipientLastName',
      contact_info: 'test@hallmark.com',
      sender_first_name: 'TestSenderFirstName',
      sender_last_name: 'TestSenderLastName',
      sender_email: 'TestSender@hallmark.com',
      url: 'https://testurl.com',
      view_date: '2020-06-03T16:48:13.6580358Z',
      view_notification_date: '2020-06-04T16:48:13.6580358Z',
      recipient_type_code: 'E',
      created_at: '2020-06-09T03:51:45.013368587Z',
      last_updated_at: '2020-06-09T03:51:45.013368587Z',
    },
  ],
};

export const saveDigitalAddressResponse: SaveDigitalAddress = {
  meta: {
    code: 201,
    version: '2.2.0',
  },
  data: {
    recipient_id: 'de2f6bfc-aa93-493a-a9e2-ffbe75bf3061',
    recipient_first_name: 'TestRecipientFirstName',
    recipient_last_name: 'TestRecipientLastName',
    contact_info: 'test@hallmark.com',
    sender_first_name: 'TestSenderFirstName',
    sender_last_name: 'TestSenderLastName',
    sender_email: 'TestSender@hallmark.com',
    url: 'https://testurl.com',
    view_date: '2020-06-03T16:48:13.6580358Z',
    view_notification_date: '2020-06-04T16:48:13.6580358Z',
    recipient_type_code: 'E',
    created_at: '2020-06-09T03:51:45.013368587Z',
    last_updated_at: '2020-06-09T03:51:45.013368587Z',
  },
};
